module.exports = __webpack_public_path__ + "static/media/README.7c61ea40.md";